export const getCurrentVoiceovers = (voiceovers, videoDuration) => {
  /*
   * This logic is needed to keep the original offset and action duration values after
   * the video is trimmed (if the user returns the original duration of the video,
   * the actions will be saved for the original video)
   *
   * Step 1: Sort by offset
   * Step 2: Remove voiceovers that begin after the new video duration value
   * Step 3: If the action starts before the new vieo duration value
   * and ends after - cut the voiceover duration to the new video duration value
   */

  return voiceovers
    .sort((a, b) => (a.storyOffset + a.trimStartOffset) - (b.storyOffset + b.trimStartOffset))
    .filter(({ storyOffset, trimStartOffset }) => (storyOffset + trimStartOffset) <= videoDuration)
    .map(voiceover =>
      (voiceover.storyOffset + voiceover.trimEndOffset) > videoDuration
        ? { ...voiceover, trimEndOffset: videoDuration - voiceover.storyOffset }
        : voiceover
    );
};
